import { api } from "../services/api";
import brasilAPI from "../services/brasilAPI";

import { getCidadeDestinoPorEstado, isStatePartiallyAttended  } from '../assets/estadosAtendidosParcialmente'

export default {
  onComplete(completed) {
    this.completed = completed;

    this.$refs.flowform.submitted = true;

    // Pega todas as informações que o cliente preencheu
    const data = this.getData();

    this.onSendData(data)
  },

  async onSendData(data) {
    this.loading = true;

    let parsedData;

    // Se é um dos Estados que são parcialmente atendidos, busca as informações (cidadeDestino e cepEntrega) diretamente aqui no frontend
    if (isStatePartiallyAttended(data.estadoDestino)) {
      const cidadeDestino = getCidadeDestinoPorEstado(data) // Manda todos os dados pois o id "cidadeDestinoSIGLA" pode ser mudar lá no arquivo

      parsedData = {
        ...data,
        cidadeDestino: cidadeDestino.cidade,
        cepEntrega: cidadeDestino.cep
      }
    } else {
      // Se é um dos Estados 100% atendidos, pega o nome da cidade pelo cepEntrega através da BrasilAPI
      const parsedCEP = data['cepEntrega'].replace('-', '')

      try {
        const cidadeDestino = await this.getCityByCEP(parsedCEP);

        parsedData = {
          ...data,
          cidadeDestino,
          cepEntrega: parsedCEP
        }

      } catch (err) {
        console.error(err);
        parsedData = data
      }
    }
   
    try {
      const response = await api.post("/api/toc", parsedData, {
        auth: {
          username: 'TOC',
          password: '9x8ykAG7SNnA9jpa',
        }
      });
      
      this.setNumeroColeta(response.data.numeroColeta);
      this.loading = false;
    } catch (err) {
      console.error('err',err);
      
      if (err.response && err.response.data) {
        this.errorMessage = err.response.data.message;
      } else {
        this.errorMessage = 'ERRO INTERNO'
      }

      this.error = true;
      this.loading = false;
    }
  },

  setNumeroColeta(numeroColeta) {
    if (numeroColeta !== -1) {
      this.coletaNumber = numeroColeta;
      this.error = false;

      this.loading = false;
    } else {
      this.error = true;
      this.loading = false;
    }
  },

  getData() {
    let data = {};

    this.questions.forEach((question) => {
      if (question.id) {
        data[question.id] = question.answer
      }
    });

    return data;
  },

  getColetaNumber() {
    return this.coletaNumber;
  },

  async getCityByCEP(cep) {
    const response = await brasilAPI.get(`/${cep}`);

    return response.data.city;
  }
};
